module.exports = __webpack_public_path__ + "190223a3f86b72c56f336bbf28f8c0e9.svg";